import React from "react";

export const Spacer = ({ props }) => <div style={{ flex: 1 }}></div>;
